export const serviceMixin = {
    name: 'serviceMixin',
    data() {
      return {
        servicebusy: false,
        boodschap: null
      }
    },
    methods: {
      get(url, config = {}) {
        this.servicebusy = true;
          return this.$http.get(url, config).finally(() => {
            this.servicebusy = false;
          });
      },
      getBlob(url) {
        return this.$http.get(url, { responseType: "arraybuffer" });
      },
      getEndpoint(url,result,prop,key,callback) {
        var vm = this
        this.get(url).then(function(response) {
        console.log("Loaded", response.data);
          vm.$set(result,prop,response.data[key])
        })
        .catch(function( error ) {
          console.log("Error --" , error);
        })
        .finally(() => {
           if (callback) vm[callback]()
        });
      },
      post(url,data) {
        return this.$http.post(url,data)
      },
      delete(url) {
        return this.$http.delete(url)
      },
      deletePost(url,data) {
        return this.$http.delete(url, { data: data })
      },
      put(url,data) {
        return this.$http.put(url,data)
      },
      postMultipart(url,formdata) {
        return this.$http.post(url, formdata, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
      }
    }
  };
  